function createXHR() {
    // @ts-expect-error: XDomainRequest is IE-specific API, therefore it was removed from `lib.d.ts`. See: https://github.com/Microsoft/TypeScript/issues/2927.
    if (typeof XDomainRequest !== 'undefined') {
        // @ts-expect-error: Read the comment above.
        return new XDomainRequest();
    }
    return new XMLHttpRequest();
}
export function fetch(uri, options) {
    if (options === void 0) { options = {}; }
    var method = options.method || 'GET';
    var xhr = createXHR();
    xhr.withCredentials = true;
    var promise = new Promise(function (resolve, reject) {
        xhr.onerror = reject;
        xhr.ontimeout = reject;
        xhr.onload = function () {
            resolve({
                ok: xhr.status >= 200 && xhr.status < 300,
                status: xhr.status,
                statusText: xhr.statusText,
                text: function () { return Promise.resolve(xhr.responseText); },
                json: function () { return Promise.resolve(JSON.parse(xhr.responseText)); },
            });
        };
    });
    xhr.open(method, uri);
    xhr.send(options.body);
    return promise;
}
